// @flow

import * as React from "react";

type ServerErrorMessageType = {
    children?: React.Node,
    className?: string,
    center?: boolean,
};

const ServerErrorMessage = (props: ServerErrorMessageType): any => {
    const classList = [];
    classList.push("server-error-message");

    if (props.className) {
        classList.push(props.className);
    }

    if (props.center) {
        classList.push("server-error-message--center");
    }

    if (props.children) {
        return (
            <fieldset className={classList.join(" ")}>
                {props.children}
            </fieldset>
        );
    } else {
        return null;
    }
};

export default ServerErrorMessage;
